import {CloseButton, Modal, ModalTitle,} from "react-bootstrap";
import ModalHeader from "react-bootstrap/ModalHeader";
import React, {useEffect, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {EventsList} from "./EventsList";
import {faChampagneGlasses,} from "@fortawesome/free-solid-svg-icons";
import {EventsDetails} from "./EventsDetails";
import {EventsDelete} from "./EventsDelete";
import {DIALOG_OPTIONS} from "../../types/DialogOptionsType";
import {RREventType} from "../../types/RREventType";
import {useAppSelector} from "../../hooks";
import {selectPreselectedEvent} from "../../../features/AppStateSlice";

export function EventsDialog({zIndex, show, onClose, onSelect}: DIALOG_OPTIONS) {

    const [viewMode, setViewMode] = useState<"VIEW_LIST" | "VIEW_ADD" | "VIEW_EDIT" | "VIEW_DELETE">('VIEW_LIST');
    const [editDocument, setEditDocument] = useState<RREventType | null>(null);
    const [deleteDocument, setDeleteDocument] = useState<RREventType | null>(null);
    const [addDocument, setAddDocument] = useState(false);

    const preselectedEvent = useAppSelector(selectPreselectedEvent);

    useEffect(() => {
        if(preselectedEvent) {
            setEditDocument(preselectedEvent);
        }
    }, [preselectedEvent]);

    useEffect(() => {
        setViewMode(editDocument ? "VIEW_EDIT" : "VIEW_LIST");
    }, [editDocument])

    useEffect(() => {
        setViewMode(deleteDocument ? "VIEW_DELETE" : "VIEW_LIST");
    }, [deleteDocument])

    useEffect(() => {
        setViewMode(addDocument ? "VIEW_ADD" : "VIEW_LIST");
    }, [addDocument])

    return (
            <Modal show={show} size={"xl"} style={{zIndex: (zIndex + 1)}}>
                <ModalHeader>
                    <ModalTitle>
                        <FontAwesomeIcon icon={faChampagneGlasses}/> Списък на събитията
                    </ModalTitle>
                    <CloseButton onClick={() => onClose(null)} />
                </ModalHeader>
                {
                    <EventsList onClose={onClose} isVisible={viewMode === "VIEW_LIST"}
                                onSelect={onSelect}
                                onAdd={() => setAddDocument(true)}
                                onEdit={(doc: RREventType ) => {
                                     setEditDocument(doc);
                                 }}
                                onDelete={(doc: RREventType) => {
                                     setDeleteDocument(doc);
                                 }}
                    />
                }
                {
                    viewMode === "VIEW_EDIT" && editDocument &&
                    <EventsDetails event={editDocument}
                                   zIndex={(zIndex || 1100) + 10}
                                   onDone={() => {
                                      setEditDocument(null)
                                  }}/>
                }
                {
                    viewMode === "VIEW_DELETE" && deleteDocument &&
                    <EventsDelete doc={deleteDocument} onDone={() => {
                        setDeleteDocument(null)
                    }}/>
                }
                {
                    viewMode === "VIEW_ADD" && addDocument &&
                    <EventsDetails event={null}
                                   zIndex={(zIndex || 1100) + 10}
                                   onDone={() => {
                                      setAddDocument(false)
                                  }}/>
                }

            </Modal>
    )
}
